import { frontendURL } from '../../../../helper/URLHelper';

const SettingsWrapper = () => import('../Wrapper.vue');
const Users = () => import('./pages/Users.vue');

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/settings/user-management'),
      meta: {
        permissions: ['administrator'],
      },
      component: SettingsWrapper,
      props: {
        headerTitle: 'USER_MANAGEMENT.TITLE',
        icon: 'people-team',
        showBackButton: false,
      },
      children: [
        {
          path: '',
          name: 'user_management',
          component: Users,
          meta: {
            permissions: ['administrator'],
          },
        },
      ],
    },
  ],
};
